import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { PortalRoutesWrapper } from "@/app/components/auth";
import { ROUTES } from "@/app/router";
import {
  DietitianScreen,
  MicrodosingCheckInScreen,
} from "@/features/forms/screens";
import { FORMS_ROUTE } from "./constants";

export const getFormsRoute = (): RouteObject => ({
  path: FORMS_ROUTE.BASE,
  element: <PortalRoutesWrapper />,

  children: [
    {
      path: `${FORMS_ROUTE.CHECK_IN}/:productId`,
      element: <MicrodosingCheckInScreen />,
    },
    {
      path: `${FORMS_ROUTE.DIETITIAN}`,
      element: <DietitianScreen />,
    },

    { path: "*", element: <Navigate replace to={ROUTES.HOME} /> },
  ],
});
